// @flow
'use strict'

module.exports = (value /*: * */) =>
  value == null || typeof value.toString !== 'function' ? '' : value.toString()



// WEBPACK FOOTER //
// ./helpers/convertValueToString.js